const STORAGE_KEY = "voz_simulador";

const normalizeNumber = (value) => {
    const v = String(value ?? "").trim();
    if (!v) return "";
    return v
        .replace(/\./g, "")
        .replace(",", ".")
        .replace(/[^\d.]/g, "");
};

const normalizeMoneyToCents = (value) => {
    const n = normalizeNumber(value);
    if (!n) return 0;
    const float = Number(n);
    if (!Number.isFinite(float)) return 0;
    return Math.round(float * 100);
};

const normalizePercentToBasisPoints = (value) => {
    const n = normalizeNumber(value);
    if (!n) return 0;
    const float = Number(n);
    if (!Number.isFinite(float)) return 0;
    return Math.round(float * 100);
};

const formatMoneyInputBR = (rawDigits) => {
    const digits = String(rawDigits || "").replace(/\D/g, "");
    const cents = digits ? parseInt(digits, 10) : 0;
    const value = cents / 100;
    return value.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

export default function simuladorHero() {
    const form = document.querySelector(".js-simulador-form");
    console.log("form", form);
    if (!form) return;

    const btns = Array.from(form.querySelectorAll(".js-simulador-tipo"));
    const tipoInput = form.querySelector(".js-simulador-tipo-input");

    const alunosEl = form.querySelector(".js-simulador-alunos");
    const ticketEl = form.querySelector(".js-simulador-ticket");
    const inadPeriodoEl = form.querySelector(".js-simulador-inad-periodo");
    const inadPosEl = form.querySelector(".js-simulador-inad-pos");

    const applyTipo = (value) => {
        if (!tipoInput) return;
        tipoInput.value = value;
        btns.forEach((b) =>
            b.classList.toggle("is-active", b.dataset.value === value),
        );
    };

    btns.forEach((btn) => {
        btn.addEventListener("click", () =>
            applyTipo(btn.dataset.value || "colegio"),
        );
    });

    if (ticketEl) {
        ticketEl.addEventListener("input", (e) => {
            const el = e.currentTarget;
            const digits = String(el.value || "").replace(/\D/g, "");
            el.value = formatMoneyInputBR(digits);
        });

        ticketEl.addEventListener("blur", (e) => {
            const el = e.currentTarget;
            const digits = String(el.value || "").replace(/\D/g, "");
            el.value = formatMoneyInputBR(digits);
        });
    }

    form.addEventListener("submit", (e) => {
        e.preventDefault();

        try {
            sessionStorage.removeItem(STORAGE_KEY);
        } catch (err) {}

        const tipo = tipoInput
            ? String(tipoInput.value || "colegio")
            : "colegio";
        const alunos = alunosEl
            ? Math.max(0, parseInt(alunosEl.value || "0", 10) || 0)
            : 0;

        const ticketDisplay = ticketEl ? String(ticketEl.value || "") : "";
        const inadPeriodoDisplay = inadPeriodoEl
            ? String(inadPeriodoEl.value || "")
            : "";
        const inadPosDisplay = inadPosEl ? String(inadPosEl.value || "") : "";

        const payload = {
            tipo,
            alunos,
            ticket_cents: normalizeMoneyToCents(ticketDisplay),
            inad_periodo_bp: normalizePercentToBasisPoints(inadPeriodoDisplay),
            inad_pos_bp: normalizePercentToBasisPoints(inadPosDisplay),
            ticket_display: ticketDisplay,
            inad_periodo_display: inadPeriodoDisplay,
            inad_pos_display: inadPosDisplay,
            created_at: Date.now(),
        };

        try {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
        } catch (err) {}

        const actionUrl = form.getAttribute("action") || window.location.href;
        window.location.href = actionUrl;
    });
}
